declare global {
  interface Window {
    APP_API_URL: string;
    APP_ENVIRONMENT: string;
    APP_SENTRY_DSN: string;
  }
}

export const RECAPTCHA_API_KEY = process.env.REACT_APP_RECAPTCHA_API_KEY;
export const APP_TITLE = process.env.REACT_APP_TITLE_PREFIX;
export const API_URL = process.env.REACT_APP_API_URL;
// Muse (musings playback) migrated off cerebro-api to cerebro-stack. Kept separate from API_URL —
// which still serves signup/stats/portfolio/team on cerebro-api — so only the musings fetch moves.
export const MUSE_API_URL =
  process.env.REACT_APP_MUSE_API_URL || "https://api.stack.cerebro.ai";
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
